var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showMoreBtn)?_c('div',{staticClass:"fixed-btn"},[_c('img',{attrs:{"src":require("@/assets/img/orderGeneral/order_show_more@2x.png")},on:{"click":_vm.clickHandler}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }